import ToastComponent from './toast.vue'

export default {

    install: Vue => {

        const ToastConstructor = Vue.extend( ToastComponent )
        const instance = new ToastConstructor()
        instance.$mount(document.createElement('div'))
        document.body.appendChild(instance.$el)

        Vue.prototype.$mr_toast = (message, closeHandler) => {
            instance.message = message
            instance.isShow = true
            if (typeof closeHandler !== 'undefined') {
                instance.closeHandler = closeHandler
            }
        }
        
    }

}